import PropTypes from 'prop-types';
import { PiCloud, PiCloudSlash, PiWarningCircle } from 'react-icons/pi';
import './styles.css';
import './variants.css';

const AppErrorState = ({
  title,
  description,
  primaryLabel,
  onPrimaryAction,
  secondaryLabel,
  onSecondaryAction,
  debugStage,
  fullPage = false,
  variant = 'generic',
}) => {
  const StateIcon = variant === 'connectivity'
    ? PiCloudSlash
    : variant === 'bootstrap' ? PiCloud : PiWarningCircle;

  return (
  <main className={`app-error-state${fullPage ? ' app-error-state--full-page' : ''}`}>
    <section className={`app-error-state__surface app-error-state__surface--${variant}`} role="alert" aria-live="assertive">
      <span className="app-error-state__icon" aria-hidden="true">
        <StateIcon />
      </span>
      <div className="app-error-state__copy">
        <h1>{title}</h1>
        <p>{description}</p>
      </div>
      <div className="app-error-state__actions">
        <button type="button" className="app-error-state__primary" onClick={onPrimaryAction}>
          {primaryLabel}
        </button>
        {secondaryLabel && onSecondaryAction && (
          <button type="button" className="app-error-state__secondary" onClick={onSecondaryAction}>
            {secondaryLabel}
          </button>
        )}
      </div>
      {debugStage && <code className="app-error-state__debug">stage: {debugStage}</code>}
    </section>
  </main>
  );
};

AppErrorState.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  primaryLabel: PropTypes.string.isRequired,
  onPrimaryAction: PropTypes.func.isRequired,
  secondaryLabel: PropTypes.string,
  onSecondaryAction: PropTypes.func,
  debugStage: PropTypes.string,
  fullPage: PropTypes.bool,
  variant: PropTypes.oneOf(['connectivity', 'bootstrap', 'generic']),
};

export default AppErrorState;
